import { typeCheckAppModule } from "utils/typeGuards";

import { NAME } from "./constants";
import { UserManagement } from "./UserManagement";

export const userManagement = typeCheckAppModule({
    NAME,
    Container: UserManagement,
});
